import React from 'react'
import Select from 'react-select'
import moment from 'moment'

export default class WidgetHearder extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
     time: moment().format('YYYY-MM-DD')
    }
  }
  componentWillMount () {
    this.setState({time: moment().format('YYYY-MM-DD')})
  }
  setTime = (value) => {
    if(value){
     this.setState({time: value.value})
     this.props.onChange(value.value)
    }
  }
  render(){
    let days = 0
    const timeOpt = []
    while( days < 7){
      let dateTime = moment().subtract(days, 'days')
      timeOpt.push(
        { value: dateTime.format('YYYY-MM-DD'), label: (days===0) ? 'Today' : dateTime.format('D MMM') },
      )
      days++
    }
    return(
      <div className='container-fluid dash-component-container mb10'>
        <div className='col-md-12 mb10'>
            <h3 className='pull-left' style = {{color: 'black'}}>
              {this.props.title}
            </h3>
            <Select
              name="time"
              value={this.state.time}
              options={timeOpt}
              onChange={this.setTime}
              removeSelected={false}
              className = 'btn no_pd ml5 black-text pull-right mt15 select-dash'
              clearable = {false}
            />
        </div>
        {/* <div className='col-md-12'>
          <hr className='hr-slim'></hr>
        </div> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/WidgetHeader.js